import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { supabase, signIn, signUp, signOut, getUserProfile, updateUserProfile } from '../lib/supabase'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      login: async (email, password) => {
        set({ isLoading: true })
        try {
          const { data, error } = await signIn(email, password)
          if (error) throw error
          
          if (data.user) {
            // 从 user_metadata 获取 name
            const userName = data.user.user_metadata?.name || 
                           data.user.raw_user_meta_data?.name || 
                           data.user.email?.split('@')[0] || 
                           ''
            
            const { data: profile } = await getUserProfile(data.user.id)
            const user = {
              id: data.user.id,
              email: data.user.email,
              name: userName,
              plan: profile?.plan || 'free',
              usage: profile?.usage || { conversions: 0, storage: 0, lastReset: null }
            }
            
            set({ 
              user, 
              token: data.session?.access_token || null, 
              isAuthenticated: true,
              isLoading: false 
            })
          }
        } catch (error) {
          set({ isLoading: false })
          throw error
        }
      },

      register: async (name, email, password) => {
        set({ isLoading: true })
        try {
          const { data, error } = await signUp(email, password, name)
          if (error) throw error
          
          if (data.user) {
            // 从 user_metadata 获取 name
            const userName = data.user.user_metadata?.name || 
                           data.user.raw_user_meta_data?.name || 
                           name || 
                           data.user.email?.split('@')[0] || 
                           ''
            
            const user = {
              id: data.user.id,
              email: data.user.email,
              name: userName,
              plan: 'free',
              usage: { conversions: 0, storage: 0, lastReset: null }
            }
            
            set({ 
              user, 
              token: data.session?.access_token || null, 
              isAuthenticated: true,
              isLoading: false 
            })
          }
        } catch (error) {
          set({ isLoading: false })
          throw error
        }
      },

      logout: async () => {
        await signOut()
        set({ 
          user: null, 
          token: null, 
          isAuthenticated: false 
        })
      },

      checkAuth: async () => {
        try {
          const { data: { session } } = await supabase.auth.getSession()
          if (session?.user) {
            // 从 user_metadata 或 raw_user_meta_data 获取 name
            const userName = session.user.user_metadata?.name || 
                           session.user.raw_user_meta_data?.name || 
                           session.user.email?.split('@')[0] || 
                           ''
            
            const { data: profile } = await getUserProfile(session.user.id)
            const user = {
              id: session.user.id,
              email: session.user.email,
              name: userName,  // 使用从 user_metadata 获取的 name
              plan: profile?.plan || 'free',
              usage: profile?.usage || { conversions: 0, storage: 0, lastReset: null }
            }
            
            set({ 
              user, 
              token: session.access_token,
              isAuthenticated: true 
            })
          }
        } catch (error) {
          console.error('Auth check failed:', error)
        }
      },

      updateProfile: async (data) => {
        const { user } = get()
        if (!user) return

        try {
          const { data: updatedUser } = await updateUserProfile(user.id, data)
          if (updatedUser) {
            set({ user: { ...user, ...updatedUser } })
          }
        } catch (error) {
          throw error
        }
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token, 
        isAuthenticated: state.isAuthenticated 
      }),
    }
  )
)




